import GuidelineOverview from "./GuidelineOverview";

export const guidelinePageTabs = [
  {
    id: "overview",
    label: "Overview",
    component: GuidelineOverview,
  },
  {
    id: "tables",
    label: "Tables",
  },
  {
    id: "figures",
    label: "Figures",
  },
];

export const guidelinePageTabsSmallScreen = [
  {
    id: "topic",
    label: "Topic",
  },
  ...guidelinePageTabs,
];